// extracted by mini-css-extract-plugin
export default {"container":"VideoVerification_container__ZGUd5","verification__buttons":"VideoVerification_verification__buttons__wVrgz","error__text":"VideoVerification_error__text__dEO4f"};